const router = [
    {
        path: '/',
        component: () => import('./components/UnderConstruction'),
        name: 'Under-Construction',
        default: true
    },
    {
        path: "/questionnaire",
        component: () => import('./components/Layout'),
        name: "Layout",
        default: true
    },
    // {
    //     path: "/sign-up",
    //     component: () => import('./components/SignUp'),
    //     name: "SignUp",
    //     default: true
    // },
    {
        path: "/sign-in",
        component: () => import('./components/SignIn'),
        name: "SignIn",
        default: true
    },
    {
        path: "/log-out",
        component: () => import('./components/LogOut'),
        name: "LogOut",
        default: true
    },
    {
        path: "/forgot-password",
        component: () => import('./components/ForgotPassword'),
        name: "ForgotPassword",
        default: true,
    },
    {
        path: "/reset-password",
        component: () => import('./components/ResetPassword'),
        name: "ResetPassword",
        default: true,
    },
    {
        path: "/change-email",
        component: () => import('./components/ChangeEmail'),
        name: "ChangeEmail",
        default: true,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/change-password",
        component: () => import('./components/ChangePassword'),
        name: "ChangePassword",
        default: true,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/submit-application",
        component: () => import('./components/SubmitApplication'),
        name: "SubmitApplication",
        default: true,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/switch-application",
        component: () => import('./components/SwitchApplication'),
        name: "SwitchApplication",
        default: true,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/congratulations",
        component: () => import('./components/Congratulations'),
        name: "Congratulations",
        default: true,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/terms-of-use",
        component: () => import('./components/TermsOfUsePage'),
        name: "TermsOfUse",
        default: true
    },
    {
        path: "/privacy-policy",
        component: () => import('./components/PrivacyPolicyPage'),
        name: "PrivacyPolicy",
        default: true
    },
    {
        path: "/:company/:ids([a-zA-Z0-9]{15,18}&[a-zA-Z0-9]{15,18})",
        component: () => import('./components/Index'),
        name: "Index-Legacy",
        beforeEnter: (to, from, next) => {
            to.params.unique_key = `${to.params.company}/${to.params.ids}`;
            to.meta.isLegacy = true;
            next();
        }
    },
    {
        path: "/:unique_key",
        component: () => import('./components/Index'),
        name: "Index-Vanity",
        beforeEnter: (to, from, next) => {
            to.meta.isVanity = true;
            next();
        }
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: '/',
        name: "NotFound"
    }
]

export default router